import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=32e03cb0&scoped=true&"
import script from "./PurchaseList.vue?vue&type=script&lang=js&"
export * from "./PurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseList.vue?vue&type=style&index=0&id=32e03cb0&lang=scss&scoped=true&"
import style1 from "./PurchaseList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e03cb0",
  null
  
)

export default component.exports